/* eslint-disable react/react-in-jsx-scope */
import { JERSEY_SHIRT_SIZES } from '../../../constants/models'
import FormSelectInput from '../elements/FormSelectInput'
import { participantInfoDisplayFields } from '../utils/participantInfoFields'

const IndividualUserFormContent = ({ values, formDisabled }) => [
  {
    id: 'jersey-form-details',
    name: 'Jersey Selection',
    inputs: [
      ...participantInfoDisplayFields(values),
      {
        id: 'jerseySize',
        size: 12,
        field: (
          <FormSelectInput
            name="jerseySize"
            label="Jersey size"
            autoComplete="new-jerseySize"
            placeholder="Select Jersey Size"
            disabled={formDisabled}
            options={Object.entries(JERSEY_SHIRT_SIZES).map(([key, value]) => ({
              value: key,
              text: value,
            }))}
            required
          />
        ),
      },
    ],
  },
]
export default IndividualUserFormContent
